import React from 'react';
import { removeHyphensAndCapitalize } from '../helpers';
import Banner from './sections/Banner';
import { Container } from 'reactstrap';
import Header from './sections/Header';
import Footer from './sections/Footer';
import ItemDetails from '../containers/ItemDetails';
import ErrorBoundary from './sections/ErrorBoundary';
import ItemDetailsView from '../components/ItemDetailsView';
import { COFFEE, OUR_COFFEE_LINK } from '../utils/constants';
import { string } from 'prop-types';
import withCoffeeService from '../hoc/withCoffeeService';
import viewContext from '../contexts/viewContext';

const ItemPage = ({ itemId, coffeeService }) => {
  return (
    <>
      <Banner pageType={COFFEE} title={removeHyphensAndCapitalize(OUR_COFFEE_LINK)}>
        <Container>
          <Header />
        </Container>
      </Banner>

      <ErrorBoundary>
        <viewContext.Provider value={(<ItemDetailsView />)}>
          <ItemDetails
            getData={coffeeService.getItem.bind(null, COFFEE, itemId)}
            itemId={itemId}
          />
        </viewContext.Provider>
      </ErrorBoundary>

      <Footer />
    </>
  )
}

ItemPage.propTypes = {
  itemId: string.isRequired,
}

export default withCoffeeService()(ItemPage)